import React from 'react';
import UserAnalyticsPage from '../components/userAnalytics/UserAnalyticsPage';

// global_admin sees everything; marketing_manager sees only the space they have open (see
// NAV_ACCESS['/user-analytics']). The page renders its own ContentArea so the header actions
// (copy / export / refresh) can read the page's state.

const UserAnalytics = () => <UserAnalyticsPage />;

export default UserAnalytics;
